import { render, staticRenderFns } from "./comprobante-pdf.vue?vue&type=template&id=104d7b5a&scoped=true&"
import script from "./comprobante-pdf.component.ts?vue&type=script&lang=ts&"
export * from "./comprobante-pdf.component.ts?vue&type=script&lang=ts&"
import style0 from "./comprobante-pdf.vue?vue&type=style&index=0&id=104d7b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d7b5a",
  null
  
)

export default component.exports